import { render } from "./InputMaskComponent.vue?vue&type=template&id=9dd96128"
import script from "./InputMaskComponent.vue?vue&type=script&lang=js"
export * from "./InputMaskComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__